<template>
  <table class="table-steps">
    <tbody>
      <tr v-for="(item, index) in items" :key="index">
        <td><strong>{{ item.name }}:</strong></td>
        <td>{{ item.value }}</td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: null
    }
  }
}
</script>
